import {
  InvitationAccessLevel,
  InvitationStatusType,
  InvitationTokenType,
  InvitationUser,
} from '../../../projects/client';

export type CommercialInvitationAccessLevel =
  | InvitationAccessLevel.Partner
  | InvitationAccessLevel.Consumer
  | InvitationAccessLevel.CommercialOwner;

export interface PartnerAccessInvitationFormData {
  inviteeEmail: string;
  accessLevel: CommercialInvitationAccessLevel;
  // key added in viguide - invitation not sent has no status
  responseStatus?: ResponseStatus;
}

export enum ResponseStatus {
  Success = 'success',
  'Error' = 'error',
  Loading = 'loading',
}

export interface FetchedPartnerAccessInvitation {
  token: string;
  tokenType: InvitationTokenType;
  tokenExpirationDate: string;
  status: InvitationStatusType;
  installationId?: number;
  inviteeEmail: string;
  inviter: InvitationUser;
  invitee: InvitationUser;
  accessLevel: CommercialInvitationAccessLevel | undefined;
  customerNumber: string;
  companyName?: string;
  userName?: string;
  editedByAccount?: string;
  editedAt?: string;
  createdAt?: string;
  ownedByMaintainer: boolean;
  isVisible: boolean;
}

export interface RequestsArrayStatus {
  status: ResponseStatus;
  index: number;
}
